import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, getUserSettings} from '../../storage'
import InvoiceA4 from './previews/invoicea4.js'
import InvoiceCucumber from './previews/invoicecucumber'
import InvoiceThin from './previews/invoicethin'
import PreviewRetail from './previews/previewretail'
import PreviewMobile from './previews/previewmobile'
import InvoicePharma from './previews/invoicepharma'
import PreviewLattice from './previews/previewlattice'
import PreviewSimpleServiceLetterPad from './previews/previewSimpleServiceLetterPad'
import InvoiceTrader from './previews/invoicetrader'
import InvoiceTraderWithLogo from './previews/invoicetraderlogos'
import InvoiceTraderAdios from './previews/invoiceTraderAdios'
import PreviewTrader2 from './previews/previewtrader2'
import InvoiceMill from './previews/invoicemill'
import {Link } from 'react-router-dom'
import {Loader} from '../../utils/misc'
import ReactDOM from 'react-dom';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';

const A4Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 210mm; min-height: 280mm;} @page {margin: 0;size: A4 portrait;min-height: 0;}"}
  </style>
)
const Responsive = () => (

  <style>
{".preview-a4 {max-width: 210mm;} @page { width:68mm;size: portrait; margin: 0;min-height: 0;} @media print{ .preview-a4 {padding-left:0;padding-right:0;} }"}
  </style>
)

const A4Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 297mm;min-height: 190mm; } @page {margin: 0;size: A4 landscape;min-height: 0;}"}
  </style>
)

const A5Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 148mm; min-height: 190mm;} @page {margin: 0;size: A5 portrait;min-height: 0;}"}
  </style>
)

const A5Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 210mm;min-height: 0; } @page {margin: 0;size: A5 landscape;min-height: 0;}"}
  </style>
)

function invoiceFont(size, fontFamily='default') {
  if(fontFamily === 'default') {

    return <style>
    {".preview-a4,.pharma-a5{font-size: " + size + "px; }"
    +".preview-a4 .company-name {font-size: " + (size+7) + "px; } "
    + " .preview-a4 .table,.pharma-a5 .table {font-size: " + (size-1) + "px; }  "
     +"@page {font-size:" + size + "px;}"
     +"@print { .preview-a4 .table,.pharma-a5 .table  {font-size: " + (size-1) + "px; }"
      +".preview-a4 .company-name {font-size: " + (size+7) + "px; }}"
     }
    </style>
  }
  else {
    return <style>
    {".preview-a4,.pharma-a5{font-size: " + size + "px; font-family:"+ fontFamily+"; }"
    +".preview-a4 .company-name {font-size: " + (size+7) + "px; font-family:"+ fontFamily+"; }"
    + " .preview-a4 .table,.pharma-a5 .table {font-size: " + (size-1) + "px; font-family:"+ fontFamily+"; }"
     +"@page {font-size:" + size + "px;font-family:"+ fontFamily+"; }"
     +"@print { .preview-a4 .table,.pharma-a5 .table  {font-size: " + (size-1) + "px; font-family:"+ fontFamily+"; }"
      +".preview-a4 .company-name {font-size: " + (size+7) + "px; font-family:"+ fontFamily+"; }}"
     }
    </style>
  }

}


export default class PreviewInvoice extends React.Component {

  constructor(props){
    super(props)
    this.getInvoice = this.getInvoice.bind(this)
    this.editLink = this.editLink.bind(this)
    this.print = this.print.bind(this)
    this.applyLabel = this.applyLabel.bind(this)
    this.handlePageSize = this.handlePageSize.bind(this)

    this.state = {loading:true, downloading:false, page_size:"a4p", show_letterpad_header:false}
  }

  componentDidMount(){
    document.title = "Invoice " + this.props.match.params.invoice_id
    this.getInvoice(this.props.match.params.invoice_id).then((response)=>{
      this.setState({invoice:response.data.invoice, history:response.data.history,
        short_link:response.data.short_link,
        company_profile: response.data.company_profile, loading:false})
    })
  }

  print(e) {
    e.preventDefault();
    window.print();
  }
  applyLabel(e, type){
    e.preventDefault()
    this.setState({print_type:type})
  }

  editLink(){
    this.props.history.push("/invoices/edit/"+this.props.match.params.invoice_id)
  }
  handlePageSize(e) {
    let value = e.target.value
    this.setState({page_size:value})
  }
  handleHistorySelect = (invoice)=>{
    this.setState({invoice:invoice})
  }

  getInvoice(invoice_id) {
    return axios({
      url: '/get_invoice/?serial='+invoice_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  send_sms= (e)=>{
    e.preventDefault()
    let sending_sms_success
    this.setState({'sending_sms':true, sending_sms_success:sending_sms_success})
    console.log(this.refs['send_to_number'].value);
    axios({
      url: '/send_sms/',
      method:'POST',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      },
      data: {inv:this.state.short_link.invoice_uid, send_to_number: this.refs['send_to_number'].value}
    }).then((res)=>{

      this.setState({sending_sms_success:'true'})
    }).catch((err)=>{

      this.setState({sending_sms_success:'false'})
    })
  }

  send_mail = (e)=>{
    e.preventDefault()
    let sending_email_success
    this.setState({'sending_email':true, sending_email_success:sending_email_success})
    console.log(this.refs['send_to_address'].value);
    axios({
      url: '/send_mail/',
      method:'POST',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      },
      data: {inv:this.state.short_link.invoice_uid, to_address: this.refs['send_to_address'].value}
    }).then((res)=>{

      this.setState({sending_email_success:'true'})
    }).catch((err)=>{

      this.setState({sending_email_success:'false'})
    })
  }

  handleShowBrandForLetterPad = (e) =>{
    this.setState({show_letterpad_header:!this.state.show_letterpad_header})
  }

  savePdf = (e) => {
    savePDF(ReactDOM.findDOMNode(e), { });
  }


  render() {
          let shortLink
          let editLink = <Link to={"/invoices/edit/"+this.props.match.params.invoice_id} className="btn btn-primary" >Edit</Link>
          let settingsLink = <Link to={"/edit_settings/"} className="btn btn-primary" >Settings</Link>
          let printLink = <Link to="#" className="btn btn-success" onClick={this.print}>Print</Link>
          let createNew = <Link to="/invoices/create/" className="btn btn-primary">Create New Invoice</Link>
          let printOriginal = <Link to="#" className="btn btn-default btn-sm" onClick={(e)=>{this.applyLabel(e, 1)}}>Label Original <span className="hidden-sm"></span></Link>
          let printDuplicate = <Link to="#" className="btn btn-default btn-sm" onClick={(e)=>{this.applyLabel(e, 2)}}>Label Duplicate <span className="hidden-sm"></span></Link>
          let printTriplicate = <Link to="#" className="btn btn-default btn-sm" onClick={(e)=>{this.applyLabel(e, 3)}}>Label Triplicate <span className="hidden-sm"></span></Link>
          let showBrandForLetterPad
          let pageSize = <A4Portrait />
          let settings = getUserSettings()
          switch (settings.invoice_style) {
            case "res":
              pageSize = <Responsive />
              break;
            case "a4p":
              pageSize = <A4Portrait />
              break;
            case "a4l":
              pageSize = <A4Landscape />
              break;
            case "a5p":
              pageSize = <A5Portrait />
              break;
            case "a5l":
              pageSize = <A5Landscape />
              break;
            default:
              pageSize = <A4Portrait />
          }
          let invoiceFontSize = invoiceFont(settings.invoice_font_size)

          let settingsOptions = settings.options
          let print_type = this.state.print_type
          let print_label
          if(settingsOptions && print_type) {
            if(print_type ===1 ) {
              print_label = settingsOptions.label_original ? settingsOptions.label_original : ""
            }
            else if (print_type === 2) {
              print_label = settingsOptions.label_duplicate ? settingsOptions.label_duplicate : ""
            }
            else if(print_type === 3) {
              print_label = settingsOptions.label_triplicate ? settingsOptions.label_triplicate: ""
            }

          }

          if(settingsOptions) {
            invoiceFontSize = invoiceFont(settings.invoice_font_size, settingsOptions.invoice_font_family)
          }

          if(this.state.short_link) {
            let shareTxt = "https://www.goodsbill.com/share?inv="+this.state.short_link.invoice_uid
            shortLink = <a className="btn btn-success" href={"whatsapp://send?text="+shareTxt} data-action="share/whatsapp/share">whatsapp <span className="glyphicon glyphicon-share-alt" aria-hidden="true"></span></a>
          }

          let emailBtn= <button className="btn btn-success" type="submit">Email</button> , emailForm, emailMsg
          let smsBtn = <button className="btn btn-success" type="submit">SMS</button>, smsForm, smsMsg
          if(this.state.sending_email_success) {
              if(this.state.sending_email_success === 'true') {
                  emailBtn = <span className="text-success"><i className="fa fa-checked"></i> Sent successfully</span>
              }
              else {
                  emailBtn = <span className="text-danger">Could not send email</span>
              }

          }
          else if (this.state.sending_email) {
            emailBtn = <span className="text-warning">Sending...</span>
          }


          emailForm = <div><form className="form-inline" onSubmit={this.send_mail}>
            <input type="email" placeholder="Email address" className="form-control" ref="send_to_address" required />
          {emailBtn}
          </form>{emailMsg}</div>


          if(this.state.sending_sms_success) {
              if(this.state.sending_sms_success === 'true') {
                  smsBtn = <span className="text-success"><i className="fa fa-checked"></i> Sent successfully</span>
              }
              else {
                  smsBtn = <span className="text-danger">Could not send sms</span>
              }

          }
          else if (this.state.sending_sms) {
            smsBtn = <span className="text-warning">Sending...</span>
          }

          smsForm = <div>
            <form className="form-inline" onSubmit={this.send_sms}>
              <input type="number" placeholder="eg:9876543210" className="form-control" ref="send_to_number" required />
              {smsBtn}
            </form>
          </div>





          let preview_style
          if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
            preview_style = <div>
            {pageSize}
            {invoiceFontSize}
            <InvoicePharma invoice={this.state.invoice} settings={this.state.settings} company={this.state.company_profile} />
            </div>
          }
          else {

            if(typeof settings !== "undefined") {
              if(settings.imvoice_template === "modern") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<PreviewLattice savePdf={this.savePdf} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "lattice") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<PreviewLattice savePdf={this.savePdf} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "simple_service_letter_pad") {
                showBrandForLetterPad = <button onClick={this.handleShowBrandForLetterPad} className="btn btn-warning">Show Header</button>
              preview_style = <div className="row"><div className="col-xs-12">
                {pageSize}{invoiceFontSize}<PreviewSimpleServiceLetterPad savePdf={this.savePdf} print_type={print_label} show_letterpad_header={this.state.show_letterpad_header}
                 invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "mayer") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<PreviewTrader2 savePdf={this.savePdf}  handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "mobile") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<PreviewMobile savePdf={this.savePdf} handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "thin") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<InvoiceThin savePdf={this.savePdf} handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "retail_a") {
              preview_style = <div className="row"><div className="col-xs-12"> {pageSize}{invoiceFontSize}<PreviewRetail savePdf={this.savePdf} handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div></div>
              }
              else if(settings.imvoice_template === "trader_slim") {
              preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceTrader savePdf={this.savePdf}  handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
              }
              else if(settings.imvoice_template === "trader_slim_2") {
              preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceTraderWithLogo savePdf={this.savePdf}  handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
              }
              else if(settings.imvoice_template === "trader_amigos") {
                preview_style = <div>{pageSize}{invoiceFontSize}
                   <InvoiceTraderAdios
                   savePdf={this.savePdf}
                   handleHistorySelect={this.handleHistorySelect}
                   history={this.state.history}
                   print_type={print_label}
                   invoice={this.state.invoice}
                   company={this.state.company_profile} /></div>
              }
              else if(settings.imvoice_template === "trader_mill") {
              preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceMill savePdf={this.savePdf}  handleHistorySelect={this.handleHistorySelect}
                 history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
              }

              else if (settings.imvoice_template === "cucumber") {
                preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceCucumber savePdf={this.savePdf}  handleHistorySelect={this.handleHistorySelect}
                   history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
              }
              else {
                preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceA4 savePdf={this.savePdf} ref={(pdf)=>{this.pdf= pdf}} handleHistorySelect={this.handleHistorySelect}
                   history={this.state.history} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
              }
            }
            else {
              preview_style = <div>{pageSize}{invoiceFontSize}<InvoiceA4 savePdf={this.savePdf} print_type={print_label} invoice={this.state.invoice} company={this.state.company_profile} /></div>
            }

          }

            if(this.state.loading) {
                return <div><Loader /> </div>
            }
            else {
              return <div >
                  <div className="row">
                    <div className="col-xs-12">
                      <section className="small">
                          <div className="hidden-print pull-left">
                          <ul className="list-inline">
                            <li>{editLink}</li>
                            <li>{createNew}</li>
                            <li>{showBrandForLetterPad}</li>
                            <li>{printLink}</li>
                            <li>{shortLink}</li>
                            <li>{emailForm}</li>
                            <li>{smsForm}</li>
                          </ul>
                        </div>
                        <div className="hidden-print">
                          <ul className="list-inline pull-right">
                            <li>{printOriginal}</li>
                            <li>{printDuplicate}</li>
                            <li>{printTriplicate}</li>
                          </ul>
                        </div>
                      </section>
                    </div>
                  </div>


                  {preview_style}
                  </div>
            }


  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previewinvoice.js